export default __webpack_public_path__ + "static/media/art.eb68824d.jpg";